(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  let observedButton;
  const sizeObserver = new ResizeObserver((entries) => {
    const button = entries[0].target;
    const purchase = button.closest('.product-buy-btns--with-hint');
    const height = button.getBoundingClientRect().height;
    if (purchase && height) purchase.style.setProperty('--hint-button-size', `${height}px`);
  });

  const placeGiftButton = () => {
    // Original app layout is the default. Only opted-in product sections are changed.
    const section = main.querySelector('[data-drop-hint-layout="gift_icon"]');
    if (!section) {
      sizeObserver.disconnect();
      observedButton = null;
      return;
    }
    const cta = section.querySelector('#dropahint-cta');
    const purchase = section.querySelector('.product-buy-btns:has(product-form form[id^="product-form-"])');
    const trigger = cta?.querySelector('#u_body a') || cta?.querySelector('a, button');
    if (!cta || !purchase || !trigger) return;

    // Move the app block intact so its original trigger and event handlers survive.
    const block = cta.closest('.product-block--app') || cta.closest('.shopify-block') || cta;
    if (!purchase.contains(block)) {
      block.classList.add('product-drop-hint');
      purchase.classList.add('product-buy-btns--with-hint');
      purchase.appendChild(block);
    }
    const addButton = purchase.querySelector('product-form button[name="add"]');
    if (addButton && observedButton !== addButton) {
      sizeObserver.disconnect();
      sizeObserver.observe(addButton);
      observedButton = addButton;
    }
    if (!trigger.querySelector('.product-drop-hint__icon')) {
      trigger.setAttribute('aria-label', 'Drop a Hint');
      trigger.setAttribute('title', 'Drop a Hint');
      trigger.classList.add('product-drop-hint__trigger');
      if (trigger.tagName === 'BUTTON') trigger.type = 'button';
      trigger.insertAdjacentHTML('beforeend', '<svg class="product-drop-hint__icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13"/><path d="M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/></svg>');
    }
  };

  // The app may load after the theme, or rerender in the theme editor.
  let frame;
  new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      placeGiftButton();
    });
  }).observe(main, { childList: true, subtree: true });
  placeGiftButton();
})();
